
<template>
  <div>
    <b-container style="container_custom" fluid>
      <b-row>
        <b-col cols='12'>
          <b-card header-bg-variant="primary" header-text-variant="white" header="News & Notifications" class="cardStyleMb">
            <b-row>
              <!--<b-col>
                <b-icon icon="newspaper" style="color: #4dd0e1; height: 5vw; width:5vw; float:left;margin-top:50px;"></b-icon>
              </b-col>-->
              <b-col cols='10'>

                  <marquee direction = "up" scrollamount="3" behavior="scroll" height="250px"
                  onmouseover="this.stop();" onmouseout="this.start();">
                  <ul id="news">
                    <li>
                          <span class='notificationHeader' >Notice</span>
                          <br><span style='font-size:0.9rem;'><a href="https://www.apdcl.org/website/docs/documents/notice/prepaid_to_postpaid_conversion.pdf" target="_blank"> Conversion of LT postpaid connections (having smart meters installed) into prepaid connections. </a> ||  <a href="https://www.apdcl.org/website/docs/documents/notice/annexure_postpaid_to_prepaid.pdf" target="_blank"><strong> Annexure A - D </strong></a></span>
                        </li>
                    <li v-for="item in getNews" :key="item.name">
                      <span class='notificationHeader' >{{ item.type }}</span>
                      <br><span class="fontStyle"  v-html="item.name"></span>
                    </li>
                </ul>
                  </marquee>
                </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <br>
        <b-row>
          <b-col cols='12'>

          <b-card header-bg-variant="primary" header-text-variant="white" header="Ongoing Projects and Schemes" class="cardStyleMb">
            <b-row>
              <!--<b-col>
                <b-icon icon="link45deg" style="color: #4dd0e1; height: 5vw; width:5vw; float:left;margin-top:50px;"></b-icon>
              </b-col>-->
              <b-col cols='12'>
                <ul  class="cardList">
                  <!-- <li>
                    <router-link to="/SurchargeWaiver" class="card-link fontStyle"><b-icon icon="caret-right" font-scale="1"/>
                      Surcharge Waiver Scheme
                    </router-link>
                  </li> -->
                  <!-- <li><a href="https://www.apdcl.org/pmsurya/login" target="_blank" class="card-link fontStyle"><b-icon icon="caret-right" font-scale="1"  /> Vendor Registration for PM Surya Ghar <img src='https://www.apdcl.org/website/assets/new.gif'/></a></li> -->
                  <li><a href="PmSurya" class="card-link fontStyle"><b-icon icon="caret-right" font-scale="1"  /> PM Surya Ghar : Muft Bijli Yojana <!--<img src='https://www.apdcl.org/website/assets/new.gif'/>--></a></li>
                  <li><a href="RdssProject" class="card-link fontStyle"><b-icon icon="caret-right" font-scale="1"  /> RDSS Projects <!--<img src='https://www.apdcl.org/website/assets/new.gif'/>--></a></li>
                  <li><a href="Aiib" class="card-link fontStyle"><b-icon icon="caret-right" font-scale="1"  /> AIIB Projects <!--<img src='https://www.apdcl.org/website/assets/new.gif'/>--></a></li>
                  <li><router-link :to="{ path: '/Project', query: { showdiv: 'saubhagya' }}" class="card-link fontStyle"><b-icon icon="caret-right" /> SAUBHAGYA</router-link></li>
                  <li><b-link :to="{ path: '/Project', query: { showdiv: 'ipds' }}" class="card-link fontStyle"><b-icon icon="caret-right" font-scale="1"/> IPDS</b-link></li>
                  <li><b-link :to="{ path: '/Project', query: { showdiv: 'ddugjy' }}" class="card-link fontStyle"><b-icon icon="caret-right" font-scale="1" /> DDUGJY</b-link></li>
                  <li><b-link :to="{ path: '/Project', query: { showdiv: 'uday' }}" class="card-link fontStyle"><b-icon icon="caret-right" font-scale="1" /> UDAY</b-link></li>
                  <li><b-link :to="{ path: '/Project', query: { showdiv: 'akashdeep' }}" class="card-link fontStyle"><b-icon icon="caret-right" font-scale="1"  /> AKASHDEEP</b-link></li>

                  <!-- <b-link href="https://www.apdcl.org/website/docs/project/solar.pdf" target="_blank" class="card-link fontStyle"><b-icon icon="caret-right" font-scale="1"  /> Roof-Top Solar Project</b-link></li> -->
                  <li><b-link href="http://www.rodalee.com/" target="_blank" class="card-link fontStyle"><b-icon icon="caret-right" font-scale="1"  /> Roof-Top Solar Project</b-link></li>
                  <li><b-link href="http://www.rodalee.com/" target="_blank" class="card-link fontStyle"><b-icon icon="caret-right" font-scale="1"  /> PM KUSUM-Component A</b-link></li>
                  <!-- <li><b-link href="#" class="card-link fontStyle"><b-icon icon="caret-right" font-scale="1" />Surcharge Waiver Scheme</b-link></li> -->
                  <li><b-link href="OneTimeSettlement"  class="card-link fontStyle"><b-icon icon="caret-right" font-scale="1" /> One-time Settlement Scheme </b-link></li>
                </ul>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <br>
        <b-row>
          <b-col cols='12'>
            <b-card header-bg-variant="primary" header-text-variant="white" header="Quick Links" class="cardStyleMb fontStyle">
              <b-row>
                <!--<b-col>
                  <b-icon icon="link45deg" style="color: #4dd0e1; height: 5vw; width:5vw; float:left;margin-top:50px;"></b-icon>
                </b-col>-->
                <b-col cols='12'>
                  <ul class="a cardList">
                    <li>
                    <b-link href="#" class="card-link fontStyle">
                      <router-link toggle-class="r-link" to="/CorporateSalaryPackage">
                        <b-icon icon="caret-right" font-scale="1" /> Corporate Salary Package
                      </router-link>
                    </b-link>
                    <img src='https://www.apdcl.org/website/assets/new.gif' />
                  </li>
                    <li>
                      <b-link href="https://www.apdcl.org/website/docs/documents/Holiday list APDCL.pdf" target="_blank" class="card-link fontStyle">
                        <b-icon icon="caret-right" font-scale="1" />Holiday List 2026
                      </b-link>
                      <!-- <img src='https://www.apdcl.org/website/assets/new.gif' /> -->
                    </li>
                    <li>
                      <b-link href="#" class="card-link fontStyle">
                      <router-link toggle-class="r-link" to="/SolarLandApplication">
                        <b-icon icon="caret-right" font-scale="1" />LAND BANK REQUISITION APPLICATION
                      </router-link>
                      </b-link>
                      <!-- <img src='https://www.apdcl.org/website/assets/new.gif'/> -->
                    </li>
                    <li>
                        <b-link href="VldScheme"  class="card-link fontStyle">
                          <b-icon icon="caret-right" font-scale="1" /> Voluntary Load Declaration Scheme
                        </b-link>
                        <!-- <img src='https://www.apdcl.org/website/assets/new.gif'/> -->
                     </li>
                    <li>
                      <b-link href="https://www.apdcl.org/cgrf/login" target="_blank" class="card-link fontStyle"><b-icon icon="caret-right" font-scale="1"/> APDCL Consumer Grievance Redressal Portal</b-link>
                      <!--<img src='https://www.apdcl.org/website/assets/new.gif'/>-->
                    </li>
                    <li>
                      <b-icon icon="caret-right" font-scale="1" /> 
                        <b-link v-b-modal.modal-headerMobile class="card-link fontStyle">
                       Excess Payment Refund
                      </b-link>
                     <!-- <img src='https://www.apdcl.org/website/assets/new.gif'/>-->
                     </li>
                     <!--<li>
                      <b-icon icon="caret-right" font-scale="1" /> 
                      <b-link href="https://www.apdcl.org/website/docs/documents/GrivenceRedresselPolicy.pdf" target="_blank" class="card-link fontStyle">
                        Grievance Redressal Policy of APDCL under NPS
                      </b-link>
                     <img src='https://www.apdcl.org/website/assets/new.gif'/>
                     </li>
                    <li>
                      <b-link href="https://www.apdcl.org/website/docs/documents/APDCL_Calendar_2025.pdf" target="_blank" class="card-link fontStyle">
                        <b-icon icon="caret-right" font-scale="1" /> APDCL Calender 2025
                       
                    </b-link>
                  </li>-->
                    <li><b-link href="#" class="card-link fontStyle">
                      <router-link toggle-class="r-link" to="/DuplicateReceipt">
                        <b-icon icon="caret-right" font-scale="1" /> Print Duplicate Receipt
                      </router-link>
                      </b-link>
                    </li>

                    <li><b-link href="#" class="card-link fontStyle">
                        <router-link toggle-class="r-link" to="/ReprintVoucher">
                          <b-icon icon="caret-right" font-scale="1" /> Reprint Prepaid Voucher
                          </router-link>
                        </b-link>
                      </li>
                    <li>
                      <b-link href="#" class="card-link fontStyle">
                        <router-link toggle-class="r-link" to="/OnlineChangeProcess">
                        <b-icon icon="caret-right" font-scale="1" /> Online Change Process
                        </router-link>
                      </b-link>
                    </li>
                    <li>
                      <b-link href="#" class="card-link fontStyle">
                        <router-link toggle-class="r-link" to="/CheckApplStatus">
                          <b-icon icon="caret-right" font-scale="1" /> Check Application Status
                        </router-link>
                      </b-link>
                    </li>
                    <!-- <li>
                      <b-link href="#" class="card-link fontStyle">
                        <router-link toggle-class="r-link" to="/KnowConsNo">
                        <b-icon icon="caret-right" font-scale="1" /> Know 12 digit Consumer Number
                        </router-link>
                      </b-link>
                   </li> -->
                    

                    <!--<li>
                      <b-link href="https://www.bharatbillpay.com/Billpay.php" target="_blank" class="card-link fontStyle">
                        <b-icon icon="caret-right" font-scale="1" /> Pay Through Bharat Billpay
                      </b-link>
                    </li>-->

                    <li>
                      <b-link href="http://www.bijuleebandhu.com/" target="_blank" class="card-link fontStyle">
                        <b-icon icon="caret-right" font-scale="1" /> Register Complaint by Bijulee Bandhu
                      </b-link>

                    </li>

                    <li>
                      <b-link href="https://www.apdclrms.com/cms/login" target="_blank" class="card-link fontStyle">
                        <b-icon icon="caret-right" font-scale="1" /> Contract Management System
                      </b-link></li>
                    <li>
                      <b-link href="https://www.apdclrms.com/easypay/login" target="_blank" class="card-link fontStyle">
                        <b-icon icon="caret-right" font-scale="1" /> APDCL Easy Pay </b-link>
                     </li>
                    
                   <!--<li>
                      <b-link href="TanUpdate" class="card-link fontStyle">
                        <b-icon icon="caret-right" font-scale="1" /> Compliance of Sec 194Q
                      </b-link>

                    </li>--> 
                    <!-- <li>
                      <b-link href="AmicableForm" class="card-link fontStyle">
                        <b-icon icon="caret-right" font-scale="1" /> Amicable Settlement Scheme
                      </b-link>

                    </li> -->
                    <!-- <li>
                      <b-link href="SpecialRebate" class="card-link fontStyle">
                        <b-icon icon="caret-right" font-scale="1" /> Special Rebate Scheme
                      </b-link>

                    </li> -->

                    <li>
                    <b-link href="EstimateServiceCost"  class="card-link fontStyle">
                      <b-icon icon="caret-right" font-scale="1" /> Service Connection Estimate Calculator
                    </b-link>

                    </li>
                    
                    <li>
                      <b-link href="EodbReport" class="card-link fontStyle">
                        <b-icon icon="caret-right" font-scale="1" /> EODB  Report</b-link>
                        
                     </li>
                     <!-- <li>
                        <b-link href="VldScheme"  class="card-link fontStyle">
                          <b-icon icon="caret-right" font-scale="1" /> Voluntary Load Declaration Scheme
                        </b-link>
                     </li> -->
                     <li>
                      <b-link href="https://www.apdcl.org/website/docs/acts_and_rules/mobile_update_form.pdf" target="_blank" class="card-link fontStyle">
                        <b-icon icon="caret-right" font-scale="1" /> Mobile Number Update Form </b-link>
                       
                     </li>
                     <li>
                      <b-link href="https://www.apdcl.org/website/docs/RTI/RTI_FAA_and_SPIO.pdf" target="_blank" class="card-link fontStyle">
                        <b-icon icon="caret-right" font-scale="1" /> First Appellate Authority & SPIO for O/o The Managing Director, APDCL </b-link>
                      
                     </li>
                     <li><b-link href="#" class="card-link fontStyle">
                          <router-link toggle-class="r-link" to="/AssociatedSites"><b-icon icon="caret-right" font-scale="1" /> Associated Sites</router-link>
                        </b-link>
                    </li>
                    <li><b-link href="#" class="card-link fontStyle">
                          <router-link toggle-class="r-link" to="/Safety"><b-icon icon="caret-right" font-scale="1" /> Safety</router-link>
                        </b-link>
                    </li>
                    <li><b-link href="#" class="card-link fontStyle">
                      <router-link toggle-class="r-link" to="/CompositeBilling">
                        <b-icon icon="caret-right" font-scale="1" /> Composite Billing Login
                      </router-link>
                      </b-link>
                    </li>
                </ul>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
    </b-container>
  </div>
</template>
<script>
import HeaderFixed from '@/components/HeaderFixed.vue'
import { mapGetters, mapActions } from 'vuex'

//const urlCommon = "http://localhost:8081/website";
//const urlCommon = "https://www.apdcl.org/website";
export default {

  components: {
      'HeaderFixed' : HeaderFixed
    },
  data() {
      return {
       getNewsFields: [
           { key: 'type', label: '',thStyle: {width: '40vw'} },
          { key: 'name', label: '',thStyle: {width: '30vw'} },

         ]
      }

  },
  computed:
  {
    ...mapGetters([
      'getNews'
    ])
  },
  methods: {
    ...mapActions([
      'retrieveNews'

    ]),

    showDoc(id){
      var link = this.getDocument.filter(function(obj) { return obj.name == id; });
      console.log(link);
      window.open(this.$urlCommon +"/"+ link[0].path);
    }
  },
  beforeMount() {
      if(this.getNews.length == 0){
        this.retrieveNews();

      }
  },
  mounted()
  {
    // this.getNews.forEach(element => {
    // var node = document.createElement("LI");
    // node.innerHTML = ""
    // document.getElementById("news").appendChild(node);

  }

}
</script>


<style scopped="true">
  .cardStyleMb{
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.5);

  }
  .cardStyleMb:hover {
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  transition: 0.3s;
  }
  ul {
    text-align: left;
    margin: 0;
    padding: 0;
  }
  li{
    padding-top:5px;

  }
  /* .card{
    max-height: 300px;
  } 
  .container_custom{

  }*/
  .fontStyle{
    font-weight: 500;
    font-size: 0.8rem !important;
  }
  .card-header{
      font-weight: bold;
  }
  .notificationHeader{
    font-weight: 600;
    font-size: 1rem;
  }
  ul {
    list-style-type: none;
  }
  .bg-primary {
    background-color: #0288d1   !important;
}

@media only screen and (min-device-width: 320px) and (max-device-height: 568px) and (orientation : portrait) and (-webkit-device-pixel-ratio: 2){
  .fontStyle{
    font-size: 12px;
  }
}
</style>
